export class Calculator {
    static kvValues = [
        {
            50: null,
            65: 53,
            80: 83,
            100: 119,
            125: 135,
            150: 202,
            200: 435,
            250: 734,
            300: 990,
            350: 1584,
            400: 2221,
            450: 2899,
            500: 3865,
            600: 4735
        },
        {
            50: 44,
            65: 76,
            80: 116,
            100: 175,
            125: null,
            150: 400,
            200: 710,
            250: 947,
            300: 1355,
            350: 2174,
            400: 2810,
            450: 3757,
            500: 4548,
            600: 6539
        }];


    static calcPressureDifference(inputData) {
        const pressureDifference = inputData.inletPressure - inputData.outletPressure;
        if (Math.round(pressureDifference * Math.pow(10, 6)) < Math.round(0.3 * Math.pow(10, 6))) {
            return null;
        }
        return pressureDifference;
    }

    static calcFlowVelocity(inputData) {
        return Math.round(inputData.flow / (Math.PI / 4 * Math.pow(inputData.valveDimension / 1000, 2)) / 3600 * 100) / 100;
    }

    static calcValveKvValue(inputData) {
        return this.kvValues[inputData.valveBore][inputData.valveDimension];
    }

    static calcMinRecomendedFlow(inputData) {
        if (this.calcValveKvValue(inputData) == null) {
            return null
        }
        return Math.round(0.10001 * Math.sqrt(this.calcPressureDifference(inputData)) * this.calcValveKvValue(inputData));
    }

    static calcMaxRecomendedFlow(inputData) {
        //=IF(M4="NA","NA",IF( (0.781117*SQRT(I5-I6)*M4) / (3.14/4* (I2/1000)^2) / 3600  >  4,3.14/4*(I2/1000)^2*4*3600,0.7971*SQRT(I5-I6)*M4))
        if (this.calcValveKvValue(inputData) == null) {
            return null
        }
        if (((0.781117 * Math.sqrt(this.calcPressureDifference(inputData)) * this.calcValveKvValue(inputData)) / (Math.PI / 4 * Math.pow(inputData.valveDimension / 1000, 2)) / 3600) > 4) {      //(0,781117*SQRT(I5-I6)*M4)/(3,14/4*(I2/1000)^2)/3600>4
            return Math.round((Math.PI / 4) * Math.pow(inputData.valveDimension / 1000, 2) * 4 * 3600);       //3,14/4*(I2/1000)^2*4*3600}
        } else {
            return Math.round(0.7971 * Math.sqrt(this.calcPressureDifference(inputData)) * this.calcValveKvValue(inputData));     //0,781117*SQRT(I5-I6)*M4}
        }
    }

    static calcCalcedKvValue(inputData) {
        //TODO rename...
        if (this.calcValveKvValue(inputData) == null) {
            return null
        }
        return Math.round(inputData.flow / Math.sqrt(this.calcPressureDifference(inputData)))
    }

    static calcValveCapacity(inputData) {
        //=IF(M7=0;-10;IF(M4="NA";-10;IF(2,3*I6+4<I5;"-10";IF(M7/M4*100>100;100;M7/M4*100))))
        if (this.calcCalcedKvValue(inputData) == null || this.calcValveKvValue(inputData) == null || 2.3 * inputData.outletPressure + 4 < inputData.inletPressure) {
            return -10;
        }
        const valveCapacity = this.calcCalcedKvValue(inputData) / this.calcValveKvValue(inputData) * 100;
        if (valveCapacity > 100) {
            return 100;
        }
        return valveCapacity;
    }

    static calcPlugLift(inputData) {
        const vC = this.calcValveCapacity(inputData);
        const plugLift = -0.0000021507684 * Math.pow(vC, 4) + 0.000560016315 * Math.pow(vC, 3) - 0.04941995824 * Math.pow(vC, 2) + 2.492627131033 * vC;
        if (plugLift > 100) {
            return 100;
        }
        return plugLift;
    }

    static shouldShowAntiCavitationMessage(inputData) {
        return !(28/11 * inputData.outletPressure + 2 > inputData.inletPressure); //Cavitation line goes through points 0,2 & 5.5,16 // a=28/11 & b=2
    }

    static shouldShowFlowVelocityMessage(inputData) {
        return this.calcFlowVelocity(inputData) > 4;
    }

    static shouldShowDimensionalAreaMessage(inputData) {
        const valveCapacity = this.calcValveCapacity(inputData);
        return valveCapacity < 10 || valveCapacity > 80;
    }
}